/* 注文明細用の診断。個人情報・ファイルURL・フォーム全体は記録しない。 */
(() => {
  if (window.smartDesignDiagnostics) return;
  const version = 'sd-diag-20260909-1';
  const propertyName = 'properties[_sd_diag]';
  const formSelector = 'form[data-type="add-to-cart-form"]';
  const cartSelector = '.product-form__submit, .gpo-original-atc-button, .gpo-clone-atc-button, [name="add"], .shopify-payment-button';
  const selectSelector = 'select[name="select_submission_type"], select[name="select_submission_type_sd"]';
  const buttonSelector = '[data-smart-design-launch="true"]';
  const states = new Map();
  const simulatorAdding = new WeakSet();
  const clean = (value, max = 120) => String(value ?? '').replace(/[\r\n\t]/g, ' ').slice(0, max);
  const visible = (element) => {
    if (!element?.isConnected || !element.getClientRects().length) return false;
    for (let node = element; node instanceof Element; node = node.parentElement) {
      const css = getComputedStyle(node);
      if (node.hidden || css.display === 'none' || ['hidden', 'collapse'].includes(css.visibility) || css.opacity === '0') return false;
    }
    const rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  };
  const inputFor = (form) => form.querySelector(`[name="${propertyName}"]`);
  const getState = (form) => {
    const input = inputFor(form);
    const product = input?.dataset.sdProduct || form.dataset.sdDiagnosticProduct;
    if (!product) return null;
    form.dataset.sdDiagnosticProduct = product;
    const key = `${product}:${form.id}`;
    if (!states.has(key)) states.set(key, {
      product, started: performance.now(), history: [], errors: [], initialized: false,
      opened: false, saved: false, restored: false, previous: null, signature: '', attempt: null,
    });
    return states.get(key);
  };
  const record = (state, message) => {
    state.history.push(`+${Math.round(performance.now() - state.started)}ms: ${clean(message, 180)}`);
    state.history = state.history.slice(-10);
  };
  const snapshot = (form) => {
    const root = form.closest('.product__info-container');
    const selects = Array.from(root?.querySelectorAll(selectSelector) || []);
    const active = selects.filter((select) => !select.disabled && visible(select));
    const select = active[0] || selects.find((item) => !item.disabled);
    const value = select?.value || '';
    const isAi = getState(form).product.includes('_ai');
    const expected = isAi ? 'simulator' : !value ? 'pending'
      : `${value} ${select?.selectedOptions[0]?.textContent}`.includes('デザインシミュレーター') ? 'simulator' : 'normal';
    const buttons = Array.from(root?.querySelectorAll(buttonSelector) || []);
    const carts = Array.from(root?.querySelectorAll(cartSelector) || []);
    const has = (key) => Boolean(form.querySelector(`[name="properties[${key}]"]`)?.value.trim());
    const originalValue = form.querySelector('[name="properties[_original_image_urls]"]')?.value.trim();
    let originalSummary = '未設定';
    if (originalValue) {
      try {
        const urls = JSON.parse(originalValue);
        originalSummary = Array.isArray(urls) && urls.every((url) => typeof url === 'string' && url.trim())
          ? `設定済み ${urls.length}件`
          : 'データ形式を確認できません';
      } catch {
        originalSummary = 'データ形式を確認できません';
      }
    }
    return {
      expected, mode: root?.dataset.smartDesignMode || 'pending', value: clean(value),
      field: select?.name || 'なし', candidates: selects.length, active: active.length,
      buttons: buttons.length, buttonVisible: buttons.some(visible),
      carts: carts.length, cartVisible: carts.filter(visible).length,
      cartEnabled: carts.filter((cart) => !cart.disabled && cart.getAttribute('aria-disabled') !== 'true').length,
      lock: window.productPageLoadLockState?.active === true ? 'ロック中'
        : window.productPageLoadLockState?.active === false ? '解除済み' : '不明',
      pdf: has('_file_smart_pdf'), preview: has('file_smart_preview'), originals: has('_original_image_urls'),
      originalSummary,
    };
  };
  const issues = (state, s, final) => {
    const result = [];
    if (s.expected === 'simulator') {
      if (!s.buttons) result.push('起動ボタン消失');
      else if (!s.buttonVisible) result.push('起動ボタン非表示');
      if (s.cartVisible) result.push('シミュレーター選択中にカート表示');
      if (s.mode !== 'simulator') result.push('選択値と内部判定の不一致');
      if (final && (!s.pdf || !s.preview || !s.originals)) result.push('シミュレーター成果物なしでカート追加操作');
      if (final && state.attempt?.route === '通常カート操作') result.push('シミュレーター選択中に通常カート操作');
    }
    if (s.active > 1) result.push('表示中の入稿方法欄が複数');
    return result;
  };
  const rememberIssues = (state, found) => {
    for (const issue of found) {
      if (!state.errors.includes(issue)) {
        if (state.errors.length >= 12) continue;
        state.errors.push(issue);
        record(state, `異常: ${issue}`);
      }
    }
  };
  const write = (form, state, s, point, final) => {
    const current = issues(state, s, final);
    const route = state.attempt?.route || '不明';
    const complete = final && state.initialized && s.expected !== 'pending'
      && s.mode === s.expected && !current.length && !route.includes('不明')
      && (s.expected !== 'simulator' || (state.saved && route === 'シミュレーター保存後'));
    const status = state.errors.length ? '異常検知' : complete ? '正常' : '判定未完了';
    const modeName = { simulator: 'シミュレーター', normal: '通常入稿', pending: '未確定' };
    const text = [
      `【${status}】`, `検知内容: ${state.errors.join('／') || 'なし'}`,
      `復旧状況: ${!state.errors.length ? '該当なし' : complete ? '現在の不整合なし' : '未確認または不整合あり'}`,
      `追加直前の状態: ${complete ? '確認済み・正常' : final ? '不整合あり、または確認不足' : '未確認'}`,
      `形式: 1／実装版: ${version}`, `表示制御版: ${state.buttonVersion || '未確認'}`,
      `記録地点: ${point}`, `追加経路: ${route}`, `操作対象: ${state.attempt?.target || 'なし'}`,
      `商品: ${clean(state.product)}`,
      '【入稿方法】', `選択値: ${s.value || '取得不可'}`, `内部判定: ${modeName[s.mode] || '不明'}`,
      `参照欄: ${s.field}／候補数: ${s.candidates}／表示中の有効な候補数: ${s.active}`,
      '【ボタン・初期化】', `表示制御JS: ${state.initialized ? '初期化済み' : '未確認'}`,
      `起動ボタン: ${s.buttons}個／${s.buttonVisible ? '表示' : '非表示または存在なし'}`,
      `カートボタン: ${s.carts}個／表示${s.cartVisible}個／有効${s.cartEnabled}個`,
      `初期ロードロック: ${s.lock}`,
      '【作成状況】', `起動要求: ${state.opened ? 'あり' : 'なし'}`,
      `保存完了通知: ${state.saved ? 'あり' : 'なし'}`,
      `入稿用PDF URL: ${s.pdf ? '設定済み' : '未設定'}`,
      `プレビュー画像URL: ${s.preview ? '設定済み' : '未設定'}`,
      `元画像URL一覧: ${s.originalSummary}`,
      '【直近の履歴（最大10件）】', ...state.history,
      '【環境】', `ブラウザー: ${clean(navigator.userAgent, 220)}`,
      `画面サイズ: ${innerWidth}×${innerHeight}／ページ復帰: ${state.restored ? 'あり' : 'なし'}`,
    ].join('\n').slice(0, 6000);
    let input = inputFor(form);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden'; input.name = propertyName;
      input.dataset.sdDiagnostic = 'true'; input.dataset.sdProduct = state.product;
      form.appendChild(input);
    }
    input.disabled = false;
    // 不変の値を再代入するとObserverが自己発火するため、差分がある時だけ更新。
    if (input.value !== text) input.value = text;
    return text;
  };
  const safely = (form, callback) => {
    if (!(form instanceof HTMLFormElement)) return;
    try {
      const state = getState(form);
      if (state) return callback(state);
    } catch {
      const input = inputFor(form);
      if (input) input.value = `【判定未完了】\n実装版: ${version}\n理由: 診断処理で例外発生`;
    }
  };
  const observe = (root, phase, buttonVersion) => {
    root.querySelectorAll(formSelector).forEach((form) => safely(form, (state) => {
      const s = snapshot(form);
      if (phase === 'before' && state.initialized) {
        if (JSON.stringify(state.previous) !== JSON.stringify(s)) {
          record(state, `修復前: 入稿=${s.value || '未確定'}／起動=${s.buttons}個・${s.buttonVisible ? '表示' : '非表示'}／カート表示=${s.cartVisible}／候補=${s.candidates}`);
        }
        if (state.previous?.expected === s.expected) rememberIssues(state, issues(state, s, false));
        if (state.previous?.candidates && !s.candidates) {
          rememberIssues(state, ['入稿方法欄の消失']);
        }
      }
      if (phase === 'after') {
        if (!state.initialized) record(state, '表示制御JS初期化');
        state.initialized = true;
        state.buttonVersion = buttonVersion;
        rememberIssues(state, issues(state, s, false));
        const signature = JSON.stringify([s, state.errors]);
        if (state.signature !== signature) {
          record(state, `入稿=${s.value || '未確定'}／起動=${s.buttonVisible ? '表示' : '非表示'}／カート表示=${s.cartVisible}／候補=${s.candidates}`);
          state.signature = signature;
          write(form, state, s, '表示同期後', false);
        } else if (!inputFor(form)) {
          write(form, state, s, '診断欄再生成', false);
        }
        state.previous = s;
      }
    }));
  };
  const capture = (form, point, route, target) => safely(form, (state) => {
    if (route) {
      state.attempt = { route, target: clean(target), time: performance.now() };
      record(state, `追加操作: ${route}`);
    } else if (!state.attempt || performance.now() - state.attempt.time > 2000) {
      state.attempt = { route: 'フォーム送信（経路不明）', target: '不明', time: performance.now() };
    }
    const s = snapshot(form);
    rememberIssues(state, issues(state, s, true));
    return write(form, state, s, point, true);
  });
  window.smartDesignDiagnostics = { observe, capture };
  window.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest(cartSelector) : null;
    const form = button?.form || button?.closest(formSelector);
    if (!form) return;
    capture(form, 'カートクリック直前', simulatorAdding.has(form) ? 'シミュレーター保存後'
      : event.isTrusted ? '通常カート操作' : 'プログラム操作（経路不明）', button.className || button.name);
  }, true);
  window.addEventListener('submit', (event) => {
    if (event.target.matches?.(formSelector)) capture(event.target, 'フォーム送信直前');
  }, true);
  window.addEventListener('formdata', (event) => {
    if (!event.target.matches?.(formSelector)) return;
    const text = capture(event.target, '送信データ生成時');
    if (text) event.formData.set(propertyName, text);
  }, true);
  window.addEventListener('smartDesignStateChange', (event) => {
    if (!event.detail?.isOpen) return;
    document.querySelectorAll('.product__info-container ' + formSelector).forEach((form) => safely(form, (state) => {
      state.opened = true;
      state.saved = false;
      record(state, 'シミュレーター起動要求');
      write(form, state, snapshot(form), 'シミュレーター起動要求', false);
    }));
  });
  window.addEventListener('smartDesignCartAttempt', (event) => {
    const { form, phase } = event.detail || {};
    if (!(form instanceof HTMLFormElement)) return;
    if (phase === 'end') { simulatorAdding.delete(form); return; }
    safely(form, (state) => {
      const s = snapshot(form);
      state.saved = s.pdf && s.preview && s.originals;
      simulatorAdding.add(form);
      record(state, state.saved ? '保存完了・必須properties確認' : '保存後の必須properties不足');
      capture(form, 'シミュレーター追加準備', 'シミュレーター保存後', '保存完了処理');
    });
  });
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) states.forEach((state) => { state.restored = true; record(state, 'ページ復帰'); });
  });
  // エラー本文・URLクエリは保存せず、関係するアセット名と位置だけ残す。
  window.addEventListener('error', (event) => {
    const source = event.filename || (event.target instanceof HTMLScriptElement ? event.target.src : '');
    const asset = source.split('/').pop()?.split('?')[0];
    if (!['smart-design.button.js', 'smart-design.react.js'].includes(asset)) return;
    document.querySelectorAll(formSelector).forEach((form) => safely(form, (state) => {
      rememberIssues(state, [`${asset}: ${event.filename ? `実行エラー（${event.lineno}:${event.colno}）` : '読込失敗'}`]);
      write(form, state, snapshot(form), '関連JSエラー検知', false);
    }));
  }, true);
})();
